// extracted by mini-css-extract-plugin
export var barContainer = "_45-0";
export var extraThin = "_45-3";
export var fillBar = "_45-6";
export var fillContainer = "_45-4";
export var overflow = "_45-8";
export var overflowContainer = "_45-5";
export var regular = "_45-7";
export var thick = "_45-1";
export var thin = "_45-2";